import { useState } from 'react';

import { useFormDataQuery } from '@/api/getters';
import Phone from '@/assets/phone.svg?react';
import BlockOverlay from '@/components/layouts/BlockOverlay';
import Button from '@/components/ui/Button';
import { HELPFIND_PHONE } from '@/consts';
import ThankYouAll from '@/features/v2/vehicle-damage/components/thankYou/ThankYouAll';

import { useLingui } from '@lingui/react';
import { createPortal } from 'react-dom';

const FinishedAll = () => {
  const { data } = useFormDataQuery();
  const [closed, setClosed] = useState(false);

  const handleClose = () => {
    setClosed(true);
  };

  const shouldShowOverlayPortal =
    !!data?.consultant_completed_at?.stage_I_documents ||
    !!data?.consultant_completed_at?.stage_II;

  return (
    <>
      {shouldShowOverlayPortal && !closed && (
        <BlockOverlayPortal handleClose={handleClose} />
      )}
      <ThankYouAll />
    </>
  );
};

export default FinishedAll;

const BlockOverlayPortal = ({ handleClose }: { handleClose: () => void }) => {
  const { i18n } = useLingui();

  return createPortal(
    <BlockOverlay
      title={i18n.t('Zajmujemy się Twoją sprawą')}
      info={i18n.t(
        'W tym momencie nie masz możliwości udzielania kolejnych odpowiedzi, ponieważ sprawa trafiła na biurko naszych rzeczoznawców.'
      )}
      subInfo={
        <b className="font-semibold">
          {i18n.t('W przypadku pytań zapraszamy do kontaktu.')}
        </b>
      }
      onClose={handleClose}
      buttonLink={
        <Button
          intent={'primary'}
          className="disabled:bg-white"
          size={'small'}
          data-testid="call-button"
        >
          <a href={`tel:${HELPFIND_PHONE}`}>
            <Phone width={18} className="shrink-0" />
            {HELPFIND_PHONE}
          </a>
        </Button>
      }
    />,
    document.body
  );
};
